import type { ConsentParams } from '~/shared/types';

const consentParamsToCategories = (consent: ConsentParams): Array<string> => {
  const categories: Array<string> = ['necessary'];

  if (consent.analytics_storage === 'granted') categories.push('analytics');

  if (
    consent.ad_storage === 'granted' &&
    consent.ad_user_data === 'granted' &&
    consent.ad_personalization === 'granted'
  )
    categories.push('marketing');
  // COOKIES: Leave it here in case we add these cookies in the future
  // if (
  //   'functionality_storage' in consent &&
  //   'personalization_storage' in consent &&
  //   (consent.functionality_storage === 'granted' ||
  //     consent.personalization_storage === 'granted')
  // )
  //   categories.push('functional');

  return categories;
};

export default consentParamsToCategories;
